var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "layerWrapper active",
      staticStyle: { display: "block" },
      attrs: { tabindex: "0" }
    },
    [
      _c(
        "div",
        {
          ref: "layerBox",
          staticClass: "cbox layerBox popWidM",
          style: Object.assign(
            {},
            { display: "block", opacity: "1" },
            _vm.style
          )
        },
        [
          _c("div", { staticClass: "cart-popup__dialog NCAcmi_cont02_popUp" }, [
            _c("div", { staticClass: "cart-popup__content payment" }, [
              _c(
                "div",
                {
                  staticClass: "cart-popup__item-info amway-theme",
                  staticStyle: { padding: "0" }
                },
                [_vm.isVip ? [_vm._m(0)] : [_vm._m(1)]],
                2
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "cart-popup__item-link",
                staticStyle: { border: "none" }
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "bt-akl-blue btn_close NCAcmi_cont03_popup",
                    on: { click: _vm.closePopup }
                  },
                  [_vm._v("확인")]
                )
              ]
            )
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "os_noticeRes" }, [
      _c("div", { staticClass: "widS" }, [
        _c("img", {
          attrs: {
            src: require("@/views/survey2/images/activity/active_vip_01.jpg"),
            alt: "액티비티 정보 안내"
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "hidden" }, [
          _c("h3", [_vm._v("2&3&4 일차 선택 프로그램")]),
          _vm._v(" "),
          _c("dl", [
            _c("dt", [_vm._v("선택 프로그램 01")]),
            _vm._v(" "),
            _c("dd", [_vm._v("짚라인 액티비티")]),
            _vm._v(" "),
            _c("dd", [
              _vm._v(
                "소요시간 | 약 4시간 30분, 제한인원 | 130명, 차량 이동시간 | 1시간"
              )
            ])
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("자연 속 스릴 만점 액티비티")]),
          _vm._v(" "),
          _c("span", [
            _vm._v(
              "짚라인 액티비티는 치앙마이에서 빼놓을 수 없는 액티비티 중 하나입니다! 짧고 긴 코스가 다양하게 구성된 짚라인 코스 중에는 외줄타기, 사다리 건너기와 같은 코스도 포함돼\n                  있습니다. 스릴 넘치고 짜릿한 액티비티를 즐기고 싶으시다면 짚라인 액티비티를 강력 추천 드립니다!"
            )
          ]),
          _vm._v(" "),
          _c("ul", [
            _c("li", [_vm._v("제한 연령: 만6세 ~ 만 65세")]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "제한 대상: 체중 120kg 이상, 신장 120cm 이하, 고소공포증 환자, 심신미약자, 임산부"
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v("주의 사항: 음주 및 약물 복용 금지, 귀중품 소지 금지")
            ]),
            _vm._v(" "),
            _c("li", [_vm._v("준비물: 편한복장, 운동화")]),
            _vm._v(" "),
            _c("li", [_vm._v("점심 식사: 포함")])
          ])
        ]),
        _vm._v(" "),
        _c("img", {
          attrs: {
            src: require("@/views/survey2/images/activity/active_vip_02.jpg"),
            alt: "액티비티 정보 안내"
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "hidden" }, [
          _c("dl", [
            _c("dt", [_vm._v("선택 프로그램 02")]),
            _vm._v(" "),
            _c("dd", [_vm._v("래프팅 액티비티")]),
            _vm._v(" "),
            _c("dd", [
              _vm._v("소요시간 | 7시간, 제한인원 | 60명, 차량 이동시간 | 2시간")
            ])
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("매땡강에서 즐기는 짜릿한 래프팅")]),
          _vm._v(" "),
          _c("span", [
            _vm._v(
              "온몸으로 치앙마이의 자연을 만끽해보세요! 치앙마이 북동부에 흐르는 매땡강은 급류가 발달하고 자연경관이 수려하여 래프팅으로 인기가 많습니다. 온몸으로 직접 급류를 느끼며\n                  즐거운 추억을 만들어 보세요!"
            )
          ]),
          _vm._v(" "),
          _c("ul", [
            _c("li", [_vm._v("제한 연령: 만8세 ~ 만 70세")]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "제한 대상: 체중 120kg 이상, 심신 미약자, 물 공포증, 임산부"
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v("주의 사항: 음주 및 약물 복용 금지, 귀중품 소지 금지")
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v("준비물: 물에 젖어도 되는 옷 및 신발, 갈아입을 옷 및 신발")
            ]),
            _vm._v(" "),
            _c("li", [_vm._v("점심 식사: 포함")])
          ])
        ]),
        _vm._v(" "),
        _c("img", {
          attrs: {
            src: require("@/views/survey2/images/activity/active_vip_03.jpg"),
            alt: "액티비티 정보 안내"
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "hidden" }, [
          _c("dl", [
            _c("dt", [_vm._v("선택 프로그램 03")]),
            _vm._v(" "),
            _c("dd", [_vm._v("몬쨈 글램핑")]),
            _vm._v(" "),
            _c("dd", [
              _vm._v(
                "소요시간 | 약 6시간 30분, 제한인원 | 50명, 차량 이동시간 | 1시간 30분"
              )
            ])
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("치앙마이에서 만나는 힐링 가득 몬쨈 글램핑")]),
          _vm._v(" "),
          _c("span", [
            _vm._v(
              "치앙마이 시내에서 벗어나 조용하고 한가롭게 여유를 즐겨 보세요! 몬쨈은 치앙마이 매림 지역에서 가장 유명한 관광지로 태국인들이 즐겨 찾는 지역 중 한 곳입니다. 독특하게\n                  생긴 텐트에서 태국식 샤브샤브인 '무카타'와 과일을 드시면서 여유롭게 휴식을 취하실 수 있습니다. 지친 일상 속, 잠시 쉼이 필요하신 분들에게 추천 드립니다."
            )
          ]),
          _vm._v(" "),
          _c("ul", [
            _c("li", [_vm._v("준비물: 따뜻한 옷(바람막이 외투 등)")]),
            _vm._v(" "),
            _c("li", [_vm._v("점심 식사: 포함")])
          ])
        ]),
        _vm._v(" "),
        _c("img", {
          attrs: {
            src: require("@/views/survey2/images/activity/active_vip_04.jpg"),
            alt: "액티비티 정보 안내"
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "hidden" }, [
          _c("dl", [
            _c("dt", [_vm._v("선택 프로그램 04")]),
            _vm._v(" "),
            _c("dd", [_vm._v("매땡 코끼리 캠프")]),
            _vm._v(" "),
            _c("dd", [
              _vm._v(
                "소요시간 | 6시간, 제한인원 | 90명, 차량 이동시간 | 1시간 30분"
              )
            ])
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("태국 코끼리와 함께하는 교감과 공존의 시간")]),
          _vm._v(" "),
          _c("span", [
            _vm._v(
              "매땡 코끼리 캠프는 단순히 코끼리 관광을 위한 곳이 아닌 코끼리를 지켜주며 치료해주는 보호 시설이기도 합니다. 매땡 코끼리 캠프에서는 코끼리에 올라타 코끼리 트래킹을\n                  즐기실 수 있으며 다재다능한 코끼리 쇼도 관람할 수 있습니다. 그리고 전통 생활방식을 고수하며 살아가는 고산족 마을 투어도 함께 즐기실 수 있습니다."
            )
          ]),
          _vm._v(" "),
          _c("ul", [
            _c("li", [
              _vm._v(
                "주의 사항: 본인의 책임아래 아동 및 유아, 노약자 코끼리 트랙킹 체험 가능"
              )
            ]),
            _vm._v(" "),
            _c("li", [_vm._v("준비물: 편한 복장, 운동화")]),
            _vm._v(" "),
            _c("li", [_vm._v("점심 식사: 포함")])
          ])
        ]),
        _vm._v(" "),
        _c("img", {
          attrs: {
            src: require("@/views/survey2/images/activity/active_vip_05.jpg"),
            alt: "액티비티 정보 안내"
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "hidden" }, [
          _c("dl", [
            _c("dt", [_vm._v("선택 프로그램 05")]),
            _vm._v(" "),
            _c("dd", [_vm._v("도이 인타논")]),
            _vm._v(" "),
            _c("dd", [
              _vm._v(
                "소요시간 | 8시간, 제한인원 | 130명, 차량 이동시간 | 1시간 30분"
              )
            ])
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("치앙마이의 자연을 만나다")]),
          _vm._v(" "),
          _c("span", [
            _vm._v(
              "아름다운 자연경관으로 유명한 도이 인타논 국립공원에서 태국 자연 환경의 신비함과 놀라운 절경을 만나보세요! 도이 인타논 트래킹 코스를 걷다 보면 영화 '아바타'의 배경이\n                  되었던 울창한 숲을 만나 보실 수 있습니다. 그리고 왕과 왕비의 장수를 기념하는 '국왕과 왕비의 탑'을 구경하며 아름다운 정원을 관람할 수 있습니다. 마지막으로 도이 인타논\n                  국립공원에서 가장 큰 폭포인 '왓치 라탄 폭포'를 만나보실 수 있습니다."
            )
          ]),
          _vm._v(" "),
          _c("ul", [
            _c("li", [
              _vm._v(
                "주의 사항: 민소매 티셔츠, 치마, 짧은 반바지 착용자 '국왕과 왕비의 탑'출입 불가"
              )
            ]),
            _vm._v(" "),
            _c("li", [_vm._v("준비물: 따뜻한 옷(바람막이, 외투 등), 운동화")]),
            _vm._v(" "),
            _c("li", [_vm._v("점심 식사: 포함")])
          ])
        ]),
        _vm._v(" "),
        _c("img", {
          attrs: {
            src: require("@/views/survey2/images/activity/active_vip_06.jpg"),
            alt: "액티비티 정보 안내"
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "hidden" }, [
          _c("dl", [
            _c("dt", [_vm._v("선택 프로그램 06")]),
            _vm._v(" "),
            _c("dd", [_vm._v("도이수텝 & 올드시티")]),
            _vm._v(" "),
            _c("dd", [
              _vm._v(
                "소요시간 | 5시간 30분, 제한인원 | 100명, 차량 이동시간 | 1시간"
              )
            ])
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("치앙마이의 역사를 돌아보는 대표 관광코스")]),
          _vm._v(" "),
          _c("span", [
            _vm._v(
              "치앙마이 대표 관광지와 란나 왕국 역사의 숨결을 만나보세요! 도이수텝은 전 세계 수많은 관광객의 발길을 이끌고 있는 치앙마이 대표 관광지로 치앙마이 여행에서 꼭 가봐야\n                  할 명소 중 하나입니다. 올드시티 투어는 라나 왕국의 수도였던 치앙마이를 돌아보는 투어로, 란나 왕조의 역사를 곳곳에서 느끼실 수 있습니다."
            )
          ]),
          _vm._v(" "),
          _c("ul", [
            _c("li", [
              _vm._v(
                "주의 사항: 민소매 티셔츠, 치마, 짧은 반바지 착용자 사원 출입 불가"
              )
            ]),
            _vm._v(" "),
            _c("li", [_vm._v("점심 식사: 포함")])
          ])
        ]),
        _vm._v(" "),
        _c("img", {
          attrs: {
            src: require("@/views/survey2/images/activity/active_vip_07.jpg"),
            alt: "액티비티 정보 안내"
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "hidden" }, [
          _c("dl", [
            _c("dt", [_vm._v("선택 프로그램 07")]),
            _vm._v(" "),
            _c("dd", [_vm._v("반캉왓 민예마을 & 왓우몽 사원")]),
            _vm._v(" "),
            _c("dd", [
              _vm._v("소요시간 | 4시간, 제한인원 | 50명, 차량 이동시간 | 30분")
            ])
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("치앙마이에서 만나는 예술인 마을과 도심 속 사원")]),
          _vm._v(" "),
          _c("span", [
            _vm._v(
              "반캉왓 민예마을은 예술인 공동체 마을로 마을을 둘러보며 치앙마이 지역 예술가의 작품과 수공예품을 만나보실 수 있습니다. 왓우몽 사원은 고요함 속에서 명상을 하려는\n                  불자들이 모이는 곳으로 유명합니다. 사원과 큰 호수를 둘러보며 여유를 만끽해보시기를 바랍니다."
            )
          ]),
          _vm._v(" "),
          _c("ul", [
            _c("li", [
              _vm._v(
                "주의 사항: 민소매 티셔츠, 치마, 짧은 반바지 착용자 사원 출입 불가"
              )
            ]),
            _vm._v(" "),
            _c("li", [_vm._v("점심 식사: 포함")])
          ])
        ]),
        _vm._v(" "),
        _c("img", {
          attrs: {
            src: require("@/views/survey2/images/activity/active_vip_08.jpg"),
            alt: "액티비티 정보 안내"
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "hidden" }, [
          _c("dl", [
            _c("dt", [_vm._v("선택 프로그램 08")]),
            _vm._v(" "),
            _c("dd", [_vm._v("마사지 & 쇼핑몰")]),
            _vm._v(" "),
            _c("dd", [
              _vm._v("소요시간 | 5시간, 제한인원 | 50명, 차량 이동시간 | 30분")
            ])
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("태국 마사지 체험과 원님만 몰 쇼핑")]),
          _vm._v(" "),
          _c("span", [
            _vm._v(
              "여행의 피로도 풀고 쇼핑도 함께 즐겨보세요! 태국 하면 제일 먼저 떠오르는 마사지! 태국 마사지를 통해 여행의 피로를 풀어보세요. 그리고 최근 치앙마이 핫플레이스로\n                  주목받는 쇼핑몰 중 하나인 원님만 몰을 방문하여 다양한 상점과 푸드코트를 둘러볼 수 있습니다."
            )
          ]),
          _vm._v(" "),
          _c("ul", [
            _c("li", [_vm._v("제한 연령: 만 15세 이상")]),
            _vm._v(" "),
            _c("li", [_vm._v("점심 식사: 불포함(자율 중식비 제공)")])
          ])
        ]),
        _vm._v(" "),
        _c("img", {
          attrs: {
            src: require("@/views/survey2/images/activity/active_vip_09.jpg"),
            alt: "액티비티 정보 안내"
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "hidden" }, [
          _c("dl", [
            _c("dt", [_vm._v("선택 프로그램 09")]),
            _vm._v(" "),
            _c("dd", [_vm._v("호텔 휴식")]),
            _vm._v(" "),
            _c("dd", [_vm._v("SHANGRI-LA HOTEL CHIANG MAI")])
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("치앙마이 최고의 호텔에서 즐기는 호캉스")]),
          _vm._v(" "),
          _c("span", [
            _vm._v(
              "치앙마이 5성급 럭셔리 호텔인 샹그릴라 호텔 치앙마이에서 나만을 위한 호캉스를 즐겨보세요! 넓은 수영장과 피트니스 센터 이용 이외에도 Amway 리더님만을 위한\n                  액티비티가 준비되어 있습니다."
            )
          ])
        ]),
        _vm._v(" "),
        _c("img", {
          attrs: {
            src: require("@/views/survey2/images/activity/active_vip_10.jpg"),
            alt: "액티비티 정보 안내"
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "hidden" }, [
          _c("h2", [_vm._v("VIP 선택 프로그램")]),
          _vm._v(" "),
          _c("dl", [
            _c("dt", [_vm._v("골프")]),
            _vm._v(" "),
            _c("dd", [_vm._v("GREEN VALLEY GOLF CLUB")])
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("치앙마이 최고 컨디션을 자랑하는 골프클럽")]),
          _vm._v(" "),
          _c("span", [
            _vm._v(
              "그랜밸리 골프클럽은 미국의 Associates Inc.와 Dennis Griffths가 설계한 18홀 규모의 골프장으로 조니워커 골프 대회와 같은 국제 대회가 열리는\n                  골프장입니다. 그린밸리 골프 클럽에서 아름다운 자연경관을 만끽하며 라운딩을 즐겨보세요."
            )
          ])
        ]),
        _vm._v(" "),
        _c("img", {
          attrs: {
            src: require("@/views/survey2/images/activity/active_vip_11.jpg"),
            alt: "액티비티 정보 안내"
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "hidden" }, [
          _c("dl", [
            _c("dt", [_vm._v("스파")]),
            _vm._v(" "),
            _c("dd", [_vm._v("SHANGRI-LA HOTEL CHIANG MAI, CHI, THE SPA")])
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("치앙마이 샹그릴라 호텔 CHI, The SPA")]),
          _vm._v(" "),
          _c("span", [
            _vm._v(
              "호텔 내 고요한 연꽃 연못과 정원으로 둘러싸인 CHI, The SPA에서 편안한 휴식을 취하실 수 있습니다. 호텔에 머무르시면서, 치앙마이 최고의 마사지를\n                  받아보세요!"
            )
          ]),
          _vm._v(" "),
          _c("ul", [_c("li", [_vm._v("제한 연령: 만 15세 이상")])])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "os_noticeRes" }, [
      _c("div", { staticClass: "widS" }, [
        _c("img", {
          attrs: {
            src: require("@/views/survey2/images/activity/active_01.jpg"),
            alt: "액티비티 정보 안내"
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "hidden" }, [
          _c("h3", [_vm._v("2&3&4 일차 선택 프로그램")]),
          _vm._v(" "),
          _c("dl", [
            _c("dt", [_vm._v("선택 프로그램 01")]),
            _vm._v(" "),
            _c("dd", [_vm._v("짚라인 액티비티")]),
            _vm._v(" "),
            _c("dd", [
              _vm._v(
                "소요시간 | 약 4시간 30분, 제한인원 | 130명, 차량 이동시간 | 1시간"
              )
            ])
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("자연 속 스릴 만점 액티비티")]),
          _vm._v(" "),
          _c("span", [
            _vm._v(
              "짚라인 액티비티는 치앙마이에서 빼놓을 수 없는 액티비티 중 하나입니다! 짧고 긴 코스가 다양하게 구성된 짚라인 코스 중에는 외줄타기, 사다리 건너기와 같은 코스도 포함돼\n                  있습니다. 스릴 넘치고 짜릿한\n                  액티비티를 즐기고 싶으시다면 짚라인 액티비티를 강력 추천 드립니다!"
            )
          ]),
          _vm._v(" "),
          _c("ul", [
            _c("li", [_vm._v("제한 연령: 만6세 ~ 만 65세")]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "제한 대상: 체중 120kg 이상, 신장 120cm 이하, 고소공포증 환자, 심신미약자, 임산부"
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v("주의 사항: 음주 및 약물 복용 금지, 귀중품 소지 금지")
            ]),
            _vm._v(" "),
            _c("li", [_vm._v("준비물: 편한복장, 운동화")]),
            _vm._v(" "),
            _c("li", [_vm._v("점심 식사: 포함")])
          ])
        ]),
        _vm._v(" "),
        _c("img", {
          attrs: {
            src: require("@/views/survey2/images/activity/active_02.jpg"),
            alt: "액티비티 정보 안내"
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "hidden" }, [
          _c("dl", [
            _c("dt", [_vm._v("선택 프로그램 02")]),
            _vm._v(" "),
            _c("dd", [_vm._v("래프팅 액티비티")]),
            _vm._v(" "),
            _c("dd", [
              _vm._v("소요시간 | 7시간, 제한인원 | 60명, 차량 이동시간 | 2시간")
            ])
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("매땡강에서 즐기는 짜릿한 래프팅")]),
          _vm._v(" "),
          _c("span", [
            _vm._v(
              "온몸으로 치앙마이의 자연을 만끽해보세요! 치앙마이 북동부에 흐르는 매땡강은 급류가 발달하고 자연경관이 수려하여 래프팅으로 인기가 많습니다. 온몸으로 직접 급류를 느끼며\n                  즐거운 추억을 만들어\n                  보세요!"
            )
          ]),
          _vm._v(" "),
          _c("ul", [
            _c("li", [_vm._v("제한 연령: 만8세 ~ 만 70세")]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "제한 대상: 체중 120kg 이상, 심신 미약자, 물 공포증, 임산부"
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v("주의 사항: 음주 및 약물 복용 금지, 귀중품 소지 금지")
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v("준비물: 물에 젖어도 되는 옷 및 신발, 갈아입을 옷 및 신발")
            ]),
            _vm._v(" "),
            _c("li", [_vm._v("점심 식사: 포함")])
          ])
        ]),
        _vm._v(" "),
        _c("img", {
          attrs: {
            src: require("@/views/survey2/images/activity/active_03.jpg"),
            alt: "액티비티 정보 안내"
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "hidden" }, [
          _c("dl", [
            _c("dt", [_vm._v("선택 프로그램 03")]),
            _vm._v(" "),
            _c("dd", [_vm._v("몬쨈 글램핑")]),
            _vm._v(" "),
            _c("dd", [
              _vm._v(
                "소요시간 | 약 6시간 30분, 제한인원 | 50명, 차량 이동시간 | 1시간 30분"
              )
            ])
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("치앙마이에서 만나는 힐링 가득 몬쨈 글램핑")]),
          _vm._v(" "),
          _c("span", [
            _vm._v(
              "치앙마이 시내에서 벗어나 조용하고 한가롭게 여유를 즐겨 보세요! 몬쨈은 치앙마이 매림 지역에서 가장 유명한 관광지로 태국인들이 즐겨 찾는 지역 중 한 곳입니다. 독특하게\n                  생긴 텐트에서 태국식 샤브샤브인\n                  '무카타'와 과일을 드시면서 여유롭게 휴식을 취하실 수 있습니다. 지친 일상 속, 잠시 쉼이 필요하신 분들에게 추천 드립니다."
            )
          ]),
          _vm._v(" "),
          _c("ul", [
            _c("li", [_vm._v("준비물: 따뜻한 옷(바람막이, 외투 등)")]),
            _vm._v(" "),
            _c("li", [_vm._v("점심 식사: 포함")])
          ])
        ]),
        _vm._v(" "),
        _c("img", {
          attrs: {
            src: require("@/views/survey2/images/activity/active_04.jpg"),
            alt: "액티비티 정보 안내"
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "hidden" }, [
          _c("dl", [
            _c("dt", [_vm._v("선택 프로그램 04")]),
            _vm._v(" "),
            _c("dd", [_vm._v("매땡 코끼리 캠프")]),
            _vm._v(" "),
            _c("dd", [
              _vm._v(
                "소요시간 | 6시간, 제한인원 | 90명, 차량 이동시간 | 1시간 30분"
              )
            ])
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("태국 코끼리와 함께하는 교감과 공존의 시간")]),
          _vm._v(" "),
          _c("span", [
            _vm._v(
              "매땡 코끼리 캠프는 단순히 코끼리 관광을 위한 곳이 아닌 코끼리를 지켜주며 치료해주는 보호 시설이기도 합니다. 매땡 코끼리 캠프에서는 코끼리에 올라타 코끼리 트래킹을\n                  즐기실 수 있으며 다재다능한 코끼리\n                  쇼도 관람할 수 있습니다. 그리고 전통 생활방식을 고수하며 살아가는 고산족 마을 투어도 함께 즐기실 수 있습니다."
            )
          ]),
          _vm._v(" "),
          _c("ul", [
            _c("li", [
              _vm._v(
                "주의 사항: 본인의 책임아래 아동 및 유아, 노약자 코끼리 트랙킹 체험 가능"
              )
            ]),
            _vm._v(" "),
            _c("li", [_vm._v("준비물: 편한 복장, 운동화")]),
            _vm._v(" "),
            _c("li", [_vm._v("점심 식사: 포함")])
          ])
        ]),
        _vm._v(" "),
        _c("img", {
          attrs: {
            src: require("@/views/survey2/images/activity/active_05.jpg"),
            alt: "액티비티 정보 안내"
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "hidden" }, [
          _c("dl", [
            _c("dt", [_vm._v("선택 프로그램 05")]),
            _vm._v(" "),
            _c("dd", [_vm._v("도이 인타논")]),
            _vm._v(" "),
            _c("dd", [
              _vm._v(
                "소요시간 | 8시간, 제한인원 | 130명, 차량 이동시간 | 1시간 30분"
              )
            ])
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("치앙마이의 자연을 만나다")]),
          _vm._v(" "),
          _c("span", [
            _vm._v(
              "아름다운 자연경관으로 유명한 도이 인타논 국립공원에서 태국 자연 환경의 신비함과 놀라운 절경을 만나보세요! 도이 인타논 트래킹 코스를 걷다 보면 영화 '아바타'의 배경이\n                  되었던 울창한 숲을 만나 보실\n                  수 있습니다. 그리고 왕과 왕비의 장수를 기념하는 '국왕과 왕비의 탑'을 구경하며 아름다운 정원을 관람할 수 있습니다. 마지막으로 도이 인타논 국립공원에서 가장 큰 폭포인\n                  '왓치 라탄 폭포'를 만나보실 수\n                  있습니다."
            )
          ]),
          _vm._v(" "),
          _c("ul", [
            _c("li", [
              _vm._v(
                "주의 사항: 민소매 티셔츠, 치마, 짧은 반바지 착용자 '국왕과 왕비의 탑'출입 불가"
              )
            ]),
            _vm._v(" "),
            _c("li", [_vm._v("준비물: 따뜻한 옷(바람막이, 외투 등), 운동화")]),
            _vm._v(" "),
            _c("li", [_vm._v("점심 식사: 포함")])
          ])
        ]),
        _vm._v(" "),
        _c("img", {
          attrs: {
            src: require("@/views/survey2/images/activity/active_06.jpg"),
            alt: "액티비티 정보 안내"
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "hidden" }, [
          _c("dl", [
            _c("dt", [_vm._v("선택 프로그램 06")]),
            _vm._v(" "),
            _c("dd", [_vm._v("도이수텝 & 올드시티")]),
            _vm._v(" "),
            _c("dd", [
              _vm._v(
                "소요시간 | 5시간 30분, 제한인원 | 100명, 차량 이동시간 | 1시간"
              )
            ])
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("치앙마이의 역사를 돌아보는 대표 관광코스")]),
          _vm._v(" "),
          _c("span", [
            _vm._v(
              "치앙마이 대표 관광지와 란나 왕국 역사의 숨결을 만나보세요! 도이수텝은 전 세계 수많은 관광객의 발길을 이끌고 있는 치앙마이 대표 관광지로 치앙마이 여행에서 꼭 가봐야\n                  할 명소 중 하나입니다. 올드시티\n                  투어는 라나 왕국의 수도였던 치앙마이를 돌아보는 투어로, 란나 왕조의 역사를 곳곳에서 느끼실 수 있습니다."
            )
          ]),
          _vm._v(" "),
          _c("ul", [
            _c("li", [
              _vm._v(
                "주의 사항: 민소매 티셔츠, 치마, 짧은 반바지 착용자 사원 출입 불가"
              )
            ]),
            _vm._v(" "),
            _c("li", [_vm._v("점심 식사: 포함")])
          ])
        ]),
        _vm._v(" "),
        _c("img", {
          attrs: {
            src: require("@/views/survey2/images/activity/active_07.jpg"),
            alt: "액티비티 정보 안내"
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "hidden" }, [
          _c("dl", [
            _c("dt", [_vm._v("선택 프로그램 07")]),
            _vm._v(" "),
            _c("dd", [_vm._v("반캉왓 민예마을 & 왓우몽 사원")]),
            _vm._v(" "),
            _c("dd", [
              _vm._v("소요시간 | 4시간, 제한인원 | 50명, 차량 이동시간 | 30분")
            ])
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("치앙마이에서 만나는 예술인 마을과 도심 속 사원")]),
          _vm._v(" "),
          _c("span", [
            _vm._v(
              "반캉왓 민예마을은 예술인 공동체 마을로 마을을 둘러보며 치앙마이 지역 예술가의 작품과 수공예품을 만나보실 수 있습니다. 왓우몽 사원은 고요함 속에서 명상을 하려는\n                  불자들이 모이는 곳으로 유명합니다.\n                  사원과 큰 호수를 둘러보며 여유를 만끽해보시기를 바랍니다."
            )
          ]),
          _vm._v(" "),
          _c("ul", [
            _c("li", [
              _vm._v(
                "주의 사항: 민소매 티셔츠, 치마, 짧은 반바지 착용자 사원 출입 불가"
              )
            ]),
            _vm._v(" "),
            _c("li", [_vm._v("점심 식사: 포함")])
          ])
        ]),
        _vm._v(" "),
        _c("img", {
          attrs: {
            src: require("@/views/survey2/images/activity/active_08.jpg"),
            alt: "액티비티 정보 안내"
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "hidden" }, [
          _c("dl", [
            _c("dt", [_vm._v("선택 프로그램 08")]),
            _vm._v(" "),
            _c("dd", [_vm._v("마사지 & 쇼핑몰")]),
            _vm._v(" "),
            _c("dd", [
              _vm._v("소요시간 | 5시간, 제한인원 | 50명, 차량 이동시간 | 30분")
            ])
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("태국 마사지 체험과 원님만 몰 쇼핑")]),
          _vm._v(" "),
          _c("span", [
            _vm._v(
              "여행의 피로도 풀고 쇼핑도 함께 즐겨보세요! 태국 하면 제일 먼저 떠오르는 마사지! 태국 마사지를 통해 여행의 피로를 풀어보세요. 그리고 최근 치앙마이 핫플레이스로\n                  주목받는 쇼핑몰 중 하나인 원님만 몰을\n                  방문하여 다양한 상점과 푸드코트를 둘러볼 수 있습니다."
            )
          ]),
          _vm._v(" "),
          _c("ul", [
            _c("li", [_vm._v("제한 연령: 만 15세 이상")]),
            _vm._v(" "),
            _c("li", [_vm._v("점심 식사: 불포함(자율 중식비 제공)")])
          ])
        ]),
        _vm._v(" "),
        _c("img", {
          attrs: {
            src: require("@/views/survey2/images/activity/active_09.jpg"),
            alt: "액티비티 정보 안내"
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "hidden" }, [
          _c("dl", [
            _c("dt", [_vm._v("선택 프로그램 09")]),
            _vm._v(" "),
            _c("dd", [_vm._v("호텔 휴식")]),
            _vm._v(" "),
            _c("dd", [_vm._v("SHANGRI-LA HOTEL CHIANG MAI")])
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("치앙마이 최고의 호텔에서 즐기는 호캉스")]),
          _vm._v(" "),
          _c("span", [
            _vm._v(
              "치앙마이 5성급 럭셔리 호텔인 샹그릴라 호텔 치앙마이에서 나만을 위한 호캉스를 즐겨보세요! 넓은 수영장과 피트니스 센터 이용 이외에도 Amway 리더님만을 위한\n                  액티비티가 준비되어 있습니다."
            )
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7317cd86", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7317cd86","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/survey2/components/SurveyPopupLayerActivity.vue
// module id = null
// module chunks = 